import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getMe, logout } from "../api/mockApi";

const routeCrumbs = (pathname) => {
  // 필요 시 추가로 매핑 확장
  if (pathname.startsWith("/cms/boards/master")) return ["게시판 관리", "게시판 생성관리"];
  if (pathname.startsWith("/cms/boards/post"))   return ["게시판 관리", "게시물 생성관리"];
  if (pathname.startsWith("/cms/popups"))        return ["팝업 관리"];
  if (pathname.startsWith("/cms/usage"))        return ["통계 관리"];
  return [];
};

export default function Topbar({ onMenu, me, logout, trail = [] }) {
  const nav = useNavigate();
  const { pathname } = useLocation();

  // 1) 라우트 기준 기본 브레드크럼
  const baseCrumbs = routeCrumbs(pathname);
  // 2) 페이지에서 추가로 주고 싶은 trail(예: 공지/문의 탭)을 합성
  const crumbs = [...baseCrumbs, ...trail].filter(Boolean);

  return (
    <div className="container-fluid py-2 d-flex align-items-center justify-content-between">
      <button
        className="btn btn-sm btn-outline-secondary btn-rounded d-lg-none me-2"
        onClick={onMenu}
      >
        <i className="fa-solid fa-bars"></i>
      </button>

      {/* 가운데: 브레드크럼 */}
      <div className="d-flex align-items-center gap-2 text-muted-2 small">
        <i className="fa-solid fa-list"></i>
        {crumbs.length ? (
          <nav aria-label="breadcrumb" style={{ ["--bs-breadcrumb-divider"]: "'>'" }}>
            <ol className="breadcrumb mb-0">
              {crumbs.map((c, i) => (
                <li
                  key={i}
                  className={
                    "breadcrumb-item " + (i === crumbs.length - 1 ? "active" : "")
                  }
                  aria-current={i === crumbs.length - 1 ? "page" : undefined}
                >
                  {c}
                </li>
              ))}
            </ol>
          </nav>
        ) : (
          <span className="text-muted-2 small"></span>
        )}
      </div>

      {/* 우측: 유저 드롭다운 */}
      <div className="d-flex align-items-center gap-2">
        <div className="dropdown">
          <button
            className="btn btn-sm btn-primary btn-rounded dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <i className="fa-regular fa-user me-1"></i>
            {me?.name || "게스트"}
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  logout();
                  nav("/cms/login");
                }}
              >
                로그아웃
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}